export default __webpack_public_path__ + "static/media/waterfallbg.40f9b493.jpg";